<template>
  <v-card max-width="960" :disabled="loading" elevation="0" rounded="xl" class="my-16 mx-auto">
    <v-card-title>
      <v-tooltip left color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :to="{ name: 'complaint-request' }"
            large
            depressed
            fab
            color="nightDark"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon size="32" color="white">{{ icons.mdiArrowLeft }}</v-icon>
          </v-btn>
        </template>
        <span>Geri Git</span>
      </v-tooltip>
      <v-divider vertical class="mx-4" />
      <v-icon large left>
        {{ icons.mdiCommentAlert }}
      </v-icon>
      <div class="ml-3">Yeni Şikayet veya İstek Ekle</div>
      <v-spacer />
    </v-card-title>

    <v-card-text class="my-6">
      <validation-observer ref="form">
        <v-row dense>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="İlgili Departman"
              rules="required"
            >
              <v-select
                v-model="data.unit"
                label="İlgili Departman"
                :items="complaintRequestStore.relatedDepartments"
                dark
                background-color="grey"
                rounded
                :menu-props="{ bottom: true, offsetY: true }"
                :error-messages="errors"
                filled
                return-object
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Konu"
              rules="required"
            >
              <v-text-field
                v-model="data.stext"
                filled
                background-color="grey"
                dark
                label="Konu"
                autocomplete="name"
                :error-messages="errors"
                rounded
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Mesaj"
              rules="required"
            >
              <v-sheet
                :color="errors.length === 0 ? 'grey' : 'error'"
                min-height="400"
                rounded="xl"
                class="overflow-hidden py-3 px-1"
              >
                <TiptapVuetify
                  v-model="data.message"
                  :extensions="extensions"
                  :error-messages="errors"
                  placeholder="Lütfen şikayet veya isteğinizi yazınız...'"
                />
              </v-sheet>
            </validation-provider>
          </v-col>
        </v-row>
      </validation-observer>
    </v-card-text>
    <v-card-actions class="pb-8">
      <v-file-input
        v-model="data.file"
        outlined
        dark
        placeholder="Dosya eklemek istiyorsanız..."
        persistent-placeholder
        prepend-icon=""
        :append-icon="icons.mdiPaperclip"
        hide-details
        rounded
        full-width
      />

      <v-btn
        depressed
        style="height: 56px !important"
        width="200px"
        color="secondary"
        rounded
        x-large
        :loading="loading"
        @click="submit"
        class="text-capitalize ml-8"
        >Gönder</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import { ref, watch, computed } from "@vue/composition-api";

// Utils
import { useToast } from "vue-toastification/composition";
import { useComplaintRequestStore } from "@/stores/complaintRequest";
import { useRouter } from "@core/utils";

// Icons
import { mdiArrowLeft, mdiPaperclip, mdiCommentAlert } from "@mdi/js";

import {
  TiptapVuetify,
  Bold,
  BulletList,
  OrderedList,
  ListItem,


} from "tiptap-vuetify";

export default {
  components: { TiptapVuetify },
  setup(props, { emit }) {
    // Utils
    const complaintRequestStore = useComplaintRequestStore();
    const toast = useToast();
    const { route, router } = useRouter();

    const content = ref("");
    const extensions = ref([
      Bold,
      ListItem,
      BulletList,
      OrderedList,
    ]);

    const loading = ref(false);
    const form = ref(null);
    const data = ref({
      unit: "",
      stext: "",
      message: "",
      file: null,
    });

    const submit = async () => {
      const isValid = await form.value.validate();

      if (!isValid) {
        return;
      }
      loading.value = true;

      const formData = new FormData();
      formData.append("method", "postComplaintForm");
      formData.append("unit", data.value.unit);
      formData.append("stext", data.value.stext);
      formData.append("message", data.value.message);
      formData.append("file[0]", data.value.file);

      store
        .dispatch("uploadMethod", formData)
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error === 1) {
            throw new Error(response.msg);
          }
          router.push({ name: "complaint-request" });
          toast.success(response.msg);
        })
        .catch((e) => {
          toast.error(e.message, {
            position: "bottom-center",
          });
          setTimeout(() => {
            loading.value = false;
          }, 300);
        })
        .finally(() => {
          // Call Center Store Eski Haline Çekme
        });
    };

    return {
      form,

      loading,
      data,
      submit,
      content,
      extensions,
      complaintRequestStore,
      icons: {
        mdiArrowLeft,
        mdiPaperclip,
        mdiCommentAlert,
      },
    };
  },
};
</script>
<style lang="scss">
.tiptap-vuetify-editor {
  .v-card {
    box-shadow: none !important;
  }
}
.tiptap-vuetify-editor__content {
  background: #3b355a;
  transition: none !important;
}

.error {
  .tiptap-vuetify-editor__content {
    background: #ff4c51 !important;
  }
}
</style>
